module.exports = __webpack_public_path__ + "static/media/file-blue.ddac87bc.svg";